import React from 'react';
import { loadModulePromise } from '../../mapLoader';
import { loadReactComponent } from '../../loaders/componentLoaders';
import { mapCustomization } from './constants';

const YMapDefaultSchemeLayer = loadReactComponent(
  'YMapDefaultSchemeLayer',
  loadModulePromise,
);

const YMapDefaultFeaturesLayer = loadReactComponent(
  'YMapDefaultFeaturesLayer',
  loadModulePromise,
);

const Layers = (): JSX.Element => (
  <>
    <YMapDefaultSchemeLayer customization={mapCustomization} />
    <YMapDefaultFeaturesLayer />
  </>
);

export default Layers;
